module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/00afe457a03b1f4ef2fd2c5bfc2af196.png";